export default {
  primary: { main: "#1e1e1e" },
  secondary: { main: "#eeeeee" },
  accent: { main: "#FF7D00" },
  danger: { main: "tomato" },
};
